import React, { useState, useEffect } from 'react';

// Components
// ---------------------
import { ClickboxMenu } from '../../../../components/clickbox-menu/clickbox-menu';
import { LoadingSpinner } from '../../../../components/loading-spinner/loading-spinner';

// API
// ---------------------
import { cmsDocumentList } from '../../../../api/api';

export const getParticipantDocumentsMenuItems = () => {
  return cmsDocumentList({}, { CmsComponent: 'ParticipantDocs' });
};

export const ParticipantDocuments = React.forwardRef(({ ...props }, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    getParticipantDocumentsMenuItems()
      .then((response) => {
        const documents = response.data.documents.map((document) => {
          const params = `cmsId=${document.cmsId}&fileName=${document.meta.title}&componentType=RAW`;
          return {
            item: document.meta.title,
            path: `/sigmaxmtf/downloadDocuments?downloadType=cms&${params}`,
            isDownload: false,
            newTab: true,
          };
        });
        setMenuItems(documents);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <div
      id="participant-documents"
      aria-labelledby="participant-documents-navigation-button"
    >
      <LoadingSpinner status={isLoading} name={'Participant Documents'} />
      <div hidden={isLoading}>
        <ClickboxMenu
          menuItems={menuItems}
          aria={'Participant Documents Menu'}
        />
      </div>
    </div>
  );
});
